import { configureStore } from '@reduxjs/toolkit'
import actionPlanSlice from '../components/ActionPlan/ActionPlanSlice'

export const store = configureStore({
  reducer: {
    actionPlan: actionPlanSlice,
  },
})
